/* unplugin-vue-components disabled */import script from "./searchCodeByOrderCode.vue?vue&type=script&lang=ts&setup=true"
export * from "./searchCodeByOrderCode.vue?vue&type=script&lang=ts&setup=true"

import "./searchCodeByOrderCode.vue?vue&type=style&index=0&id=8787b450&lang=scss"

const __exports__ = script;

export default __exports__